import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { EdgeResizer } from '~src/utils';
import ProjectActions from './ProjectActions';
import styles from './ProjectItem.module.scss';
import { useEffect } from 'react';

function ProjectItem(props) {
  const elementId = `user-canvas-${props.objectId}`;
  const [isDeleted, setIsDeleted] = useState(false);
  const maxPages = 2;
  const [thumbnails, setThumbnails] = useState(
    props.gifPreviewId
      ? [`${process.env.GIOTTO_VIDEO_CDN}/${props.gifPreviewId}`]
      : [`${process.env.OFC_CDN_URL}/logos/giotto_white.png`]
  );

  const cleanedPagesPreview = props.pagesPreview.filter((page) => page);
  const pagesPreview = cleanedPagesPreview.slice(0, maxPages);

  useEffect(() => {
    if (isDeleted && props.setReload instanceof Function) {
      props.setReload([props.objectId]);
    }
  }, [isDeleted]);

  useEffect(() => {
    if (pagesPreview.length > 0) {
      const resizedThumbnails = pagesPreview.map((page) => {
        return new EdgeResizer(page).scaleToWidth(210);
      });
      setThumbnails(resizedThumbnails);
    }
  }, []);

  const url = `${process.env.ROUTE_CANVAS}/${props.objectId}`;
  return (
    <div
      id={elementId}
      style={{ display: isDeleted ? 'none' : 'block' }}
      data-user-canvas-id={props.objectId}
      className={`g-card g-flex g-flex-col g-cursor-pointer ${styles.cardNoPad} ${styles.cardNoBorder} ${styles.cardHover} ${styles.cardGutter}`}
    >
      <ProjectActions objectId={props.objectId} setIsDeleted={setIsDeleted} />
      <a className={styles.linkReset} href={url} data-navigo>
        <div
          className={`g-w-full g-flex g-items-center g-justify-center g-bg-gray-100 ${styles.projectThumb}`}
        >
          {thumbnails.map((thumbnail) => (
            <img
              key={thumbnail}
              className={`${styles.thumbImage} ${
                pagesPreview.length === 0 ? styles.noBoxShadow : ''
              } ${thumbnails.length > 1 ? styles.widthTwoPages : ''}`}
              src={thumbnail}
              loading="lazy"
              alt="Anteprima progetto"
            />
          ))}
        </div>
      </a>
      <div className={styles.projectMeta}>
        <div className={`g-text-m ${styles.projectTitle}`}>
          {props.metadata?.projectTypeName
            ? `${props.metadata?.projectTypeName}`
            : 'Progetto Senza Titolo'}{' '}
          {props.metadata?.formatName
            ? `${props.metadata?.formatName.replace('Orizzontale', '')}`
            : ''}
        </div>
        <div className={`g-text-s ${styles.projectSubtitle}`}>
          {props.metadata?.templatesCategoryName
            ? `${props.metadata?.templatesCategoryName}`
            : ''}
          {' | '}
          {props.metadata?.servizioName}
        </div>
      </div>
    </div>
  );
}

ProjectItem.propTypes = {
  objectId: PropTypes.string,
  pagesPreview: PropTypes.array,
  gifPreviewId: PropTypes.string,
  name: PropTypes.string,
  metadata: PropTypes.object,
  setReload: PropTypes.func,
};

export default ProjectItem;
